<template>
  <div>
    <div class="ListenCompo">
      <CCard class="ImageLesson">
        <!-- <div>漢字</div> -->
      </CCard>
    </div>
    <div class="info">
        <!-- <div class="Lessoninfo">漢字</div>
        <i class="cil-search"></i> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CardIntroComponent",
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {},
  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },}
};
</script>

<style>
.ListenCompo {
  padding-top: -1px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.ImageLesson {
  background-color: #808080;
  width: 100%;
  height: 399px;
  position: relative;
  /* left: -1rem;
    top: -13px; */
}
.LessonInfo {
  justify-content: center;
}
.info {
  display: flex;
  justify-content: space-between;
}
</style>